export const LOGEMENT_LESSONS_AR = [
  {
    id: 'logement-1',
    numero: 1,
    titre: "فهم طلب السكن الاجتماعي",
    sousTitre: "نموذج وطني واحد",
    contexte: "تريد الحصول على سكن اجتماعي. كيف يعمل النظام وكيف تقدّم طلبك؟",
    explication: [
      "**الطلب الوطني الموحّد**: في فرنسا، هناك نموذج طلب واحد لجميع السكنات الاجتماعية — يُقدَّم مرة واحدة فقط.",
      "**رقم التسجيل الفريد**: بعد تقديم طلبك، تحصل على رقم فريد (numéro unique) يُثبت تاريخ طلبك وأولويتك.",
      "**الموقع الرسمي**: demande-logement-social.gouv.fr — مجاني تماماً. احذر من المواقع الخاصة التي تطلب مالاً.",
      "**معايير الأولوية**: الوضع العائلي، مستوى الدخل، الحالة السكنية الراهنة (طرد، اكتظاظ...) كلها تؤثر على الأولوية.",
      "**تجديد الطلب**: كل سنة يجب تجديد طلبك وإلا يُلغى تلقائياً. ضع تذكيراً في هاتفك.",
    ],
    question: "أين يجب تقديم طلب السكن الاجتماعي؟",
    options: [
      { id: 'a', text: "على demande-logement-social.gouv.fr — مجاناً", correct: true },
      { id: 'b', text: "على مواقع عقارية خاصة مثل SeLoger", correct: false },
      { id: 'c', text: "في بلدية كل حي على حدة", correct: false },
    ],
    explication_reponse: "الموقع الرسمي والوحيد هو demande-logement-social.gouv.fr — مجاني تماماً. أي موقع آخر يطلب مالاً مقابل تقديم طلب السكن الاجتماعي هو احتيال.",
  },
  {
    id: 'logement-2',
    numero: 2,
    titre: "تقديم طلبك على الإنترنت",
    sousTitre: "خطوة بخطوة",
    contexte: "الطلب الإلكتروني بسيط إذا كنت مستعداً بالوثائق الصحيحة. إليك كيفية ذلك.",
    explication: [
      "**الوثائق الضرورية**: وثائق الهوية لجميع أفراد الأسرة، شهادة الدخل أو إشعار الضريبة، شهادة CAF إذا كنت مستفيداً.",
      "**ملء النموذج**: أدخل معلوماتك بعناية — عدد الغرف المطلوبة، المناطق المفضلة، وضعك الحالي.",
      "**الإيصال الفوري**: بعد الإرسال تتلقى فوراً إيصالاً برقم التسجيل الفريد — احتفظ به بعناية.",
      "**التعديل ممكن**: يمكنك تعديل طلبك في أي وقت على الموقع — إضافة مدن، تغيير نوع السكن...",
      "**متابعة ملفك**: سجّل الدخول إلى الموقع لتتبع حالة طلبك وتحديث معلوماتك عند الحاجة.",
    ],
    question: "ماذا تتلقى فوراً بعد تقديم طلب السكن الاجتماعي؟",
    options: [
      { id: 'a', text: "إيصال برقم التسجيل الفريد", correct: true },
      { id: 'b', text: "قائمة بالسكنات المتاحة فوراً", correct: false },
      { id: 'c', text: "موعداً مع مسكن اجتماعي", correct: false },
    ],
    explication_reponse: "رقم التسجيل الفريد هو أهم ما تحصل عليه — إنه يُثبت تاريخ طلبك وأولويتك. احتفظ به في مكان آمن.",
  },
  {
    id: 'logement-3',
    numero: 3,
    titre: "مساعدات السكن APL",
    sousTitre: "هل أنت مستحق؟",
    contexte: "تدفع إيجاراً. قد تكون مستحقاً لمساعدة APL من CAF لتخفيض تكاليف إيجارك.",
    explication: [
      "**APL** (المساعدة الشخصية للسكن): مساعدة شهرية تدفعها CAF للمستأجرين ذوي الدخل المحدود.",
      "**تُدفع مباشرة للمالك**: في معظم الحالات، CAF تدفع APL مباشرة لمالكك، وأنت تدفع الفرق فقط.",
      "**المحاكاة**: على caf.fr ← 'محاكاة APL' — نتيجة فورية لمعرفة ما إذا كنت مستحقاً ومقدار المساعدة.",
      "**الشروط الأساسية**: السكن يجب أن يكون مقر إقامتك الرئيسي، المالك يجب أن يوقّع اتفاقية مع CAF.",
      "**عدم التصريح بتغيير**: إذا انتقلت أو تغيّر وضعك دون إخبار CAF، ستطلب منك إعادة المبالغ المدفوعة.",
    ],
    question: "لمن تدفع CAF مساعدة APL في معظم الحالات؟",
    options: [
      { id: 'a', text: "مباشرة للمالك، وأنت تدفع الفرق", correct: true },
      { id: 'b', text: "لك شخصياً كل شهر", correct: false },
      { id: 'c', text: "للبلدية التي تتولى توزيعها", correct: false },
    ],
    explication_reponse: "APL تُدفع عادةً مباشرة للمالك — هذا يضمن للمالك استلام الإيجار وللمستأجر تخفيضاً تلقائياً. أنت تدفع ما تبقى فقط.",
  },
  {
    id: 'logement-4',
    numero: 4,
    titre: "في حالة مشكلة سكنية",
    sousTitre: "حقوقك وموارد المساعدة",
    contexte: "طرد، خلاف مع المالك، سكن غير لائق... هناك حلول. لست وحدك.",
    explication: [
      "**ADIL** (وكالة الإعلام حول السكن): تقديم مشورة قانونية مجانية حول حقوقك السكنية — اعثر على ADIL الخاص بك على anil.org.",
      "**الهدنة الشتوية**: بين 1 نوفمبر و31 مارس، الطرد من السكن ممنوع قانونياً في فرنسا حتى لو لم تدفع الإيجار.",
      "**IRL** (مؤشر مرجعية الإيجارات): يحدد الحد الأقصى لزيادة الإيجار من قِبل المالك — يُنشر كل ربع سنة من قِبل INSEE.",
      "**FSL** (صندوق التضامن للسكن): مساعدة للأشخاص الذين لديهم صعوبة في دفع الإيجار — تطلب عبر بلديتك أو CAF.",
      "**السكن غير اللائق**: إذا كان سكنك يمثّل خطراً (رطوبة، برد، حشرات)، أخبر بلديتك أو اتصل بـ 0806 000 515.",
    ],
    question: "متى تسري الهدنة الشتوية التي تمنع الطرد؟",
    options: [
      { id: 'a', text: "من 1 نوفمبر إلى 31 مارس", correct: true },
      { id: 'b', text: "من 1 ديسمبر إلى 28 فبراير", correct: false },
      { id: 'c', text: "طوال السنة للعائلات ذات الأطفال", correct: false },
    ],
    explication_reponse: "الهدنة الشتوية تمتد من 1 نوفمبر إلى 31 مارس — أي 5 أشهر في السنة. خلال هذه الفترة، لا يمكن طرد أي مستأجر مهما كانت الظروف.",
  },
];
